import React, { useState } from 'react';
import styles from "./styles.module.scss";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossGrayIcon.svg";

const defaultTextAreaStyles = {
    borderRadius: '4px',
    resize: 'none',
    fontSize: '12px',
    width: '300px',
    overflow: 'hidden',
    height: '29px',
}


const ATextAreaV2 = ({
    containerStyles = {},// for positioning the text area,
    style = {},
    regex,
    placeholder = 'Enter',
    searchHandler = () => { },
    crossHandler = () => { },
    initialVal = '',
    onInputChange = () => { },
    ...rest
}) => {

    const isControlled = rest.hasOwnProperty('value');

    const [userInput, setUserInput] = useState(initialVal);

    const inputVal = isControlled ? rest?.value : userInput;

    const defaultHeight = style?.height ?? '29px';

    const adjustTxtAreaHeightToUserInput = e => {
        e.target.style.height = 'auto';
        e.target.style.height = e.target.scrollHeight + "px"
    }

    const onKeyDown = e => {
        if (e.key === 'Enter' || e.keyCode === 13) inputVal && searchHandler(inputVal)
    }

    const handleChange = e => {
        const inputVal = e.target.value;
        if (regex && !regex.test(inputVal)) return;
        setUserInput(inputVal);
        onInputChange(inputVal);
        adjustTxtAreaHeightToUserInput(e);
    }

    const handleCancelClick = async () => {
        await crossHandler();
        setUserInput('');
        onInputChange('');
    }

    return (
        <div className='position-absolute' style={containerStyles}>

            <div className='position-relative'>

                <textarea
                    value={inputVal}
                    style={{ ...defaultTextAreaStyles, ...style }}
                    className={styles['text-area']}
                    placeholder={placeholder}
                    onChange={handleChange}
                    onFocus={adjustTxtAreaHeightToUserInput}
                    onBlur={e => e.target.style.height = defaultHeight}
                    onKeyDown={onKeyDown}
                    {...rest}
                />

                {inputVal &&
                    <span
                        className={'position-absolute cursor ' + styles['cross-icon']}
                        onClick={handleCancelClick}
                    >
                        <CrossIcon />
                    </span>
                }

            </div>

        </div>
    );
}

export default ATextAreaV2;